import React, { useEffect, useState } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { appStore } from "lib/state"
import { cn, queryTools } from "lib/utils"
import { Sortable } from "lib/components"
import { ElementBox } from "lib/components/elements"
import { ConditionalSummary } from "lib/units/conditional"
import { useDispute } from "lib/units/dispute/hooks"
import { StatementLogicMenu, useStatements } from "."


export default function StatementPreview({ 
  elemtype, 
  expanded=false, 
  clickFn=() => {},
  report,
  statement 
} :{ 
  elemtype:string; 
  expanded?:boolean; 
  clickFn?:Function;
  report?:any;
  statement:any 
}){
  const { dspid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams() 

  const { store, AppStore }:any = appStore()
  const { update } = AppStore

  const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { id: dspid }, { enabled: !!dspid })
  const saveFn = queryTools.resource.save(["dispute"])

  const { cloneStatementInDispute, findStatementIdxInDispute, moveStatementInDispute, removeStatementFromDispute } = useStatements({ elemtype })
  const { replaceElementSettings, replaceElementConfig } = useDispute({ saveFn })

  const [ enableSort, setEnableSort ] = useState(true)

  const reOrderStatements = (statement1:string, statement2:string) => {
    const st1Idx = findStatementIdxInDispute(_Dispute, statement1)
    const st2Idx = findStatementIdxInDispute(_Dispute, statement2)
    console.log("reOrderStatements", st1Idx, st2Idx)
    const adjustedStatements = moveStatementInDispute(_Dispute, st1Idx, st2Idx)
    replaceElementConfig(_Dispute, elemtype, adjustedStatements)
  }

  const dragNDropProps = () => {
    return {
      activated: enableSort,
      onDragStart: (e:any) => {
        const refstr = e.currentTarget.getAttribute("data-refstr")
        e.dataTransfer.setData("text/plain", JSON.stringify({ dragging: refstr }))
      },
      onDragOver: (e:any) => {
        console.log("drag over")
      },
      onDrop: (e:any) => {
        const {dragging} = JSON.parse(e.dataTransfer.getData("text/plain"))
        const refstr = e.currentTarget.getAttribute("data-refstr")
        console.log(`dragged ${dragging} over ${refstr}`)
        reOrderStatements(dragging, refstr)
      }
    }
  }

  useEffect(() => {
    console.log("report", report)
  },[report])

  if( !_Dispute ) return <></>
  return (
    <Sortable item={statement} {...dragNDropProps()}>
      <ElementBox 
        title={statement.title}
        item={statement}
        className={cn(
          (report?.verdict === false) ? "border border-solid border-red-800" : "border border-solid border-green-800",
          report == null && "border border-solid border-transparent",
          enableSort ? "cursor-move" : "cursor-pointer",
        )}
        comp={<StatementLogicMenu statement={statement} elemtype={elemtype} />}
        // editFn={ (title:string) => null }
        // buttons={[
        //   { 
        //     item: statement,
        //     label: "clone", 
        //     onClick:(statement:any) => {
        //       const updatedStatements = cloneStatementInDispute(_Dispute, statement.refstr) 
        //       console.log("updatedStatements", updatedStatements)
        //       replaceElementConfig(_Dispute, elemtype, updatedStatements)
        //     }
        //   },
        //   { 
        //     label: "delete", 
        //     item: statement, 
        //     onClick:(statement:any) => {
        //       const updatedStatements = removeStatementFromDispute(_Dispute, statement.refstr)
        //       replaceElementConfig(_Dispute, elemtype, updatedStatements)
        //     } 
        //   },
        // ]}
      >
        <div className="w-full flex">
          <div 
            onClick={() => clickFn(statement, "conditionals")}
            className="w-4/12 flex flex-col gap-2 bg-slate-900/50 px-2 py-1 cursor-pointer relative"
          >
            { statement.conditional === null ? (
              <span className="text-xs">No conditions. Content only.</span>
            ):(
              <>
                { expanded === false ? (
                  <>
                    { statement.description.length === 0 ? (
                      <span className="text-xs">Use the "toggle view" button to expand.</span>
                    ) : (
                      <span className="text-xs">{ statement.description }</span>
                    )}
                  </>
                ):(
                  <ConditionalSummary 
                    conditional={statement.conditional} 
                    report={report}
                  />
                )}
                <span className="absolute bottom-0 left-1 text-[.7rem]">{statement.refstr}</span>
              </>
            )}
          </div>
          <div className="w-8/12 flex flex-col items-stretch gap-1 cursor-pointer">
            <div 
              onClick={() => {
                update("metas.currentContentAction", "pass")
                update("actives.statement.content.pass", statement.content.pass)
                clickFn(statement, "content", "pass")
              }}
              className="w-full flex flex-col"
            >
              { statement.content.pass !== null && (
                <div className="w-full bg-green-900/50 px-2 py-1">
                  { expanded === false ? (
                    <span dangerouslySetInnerHTML={{ __html: statement.content.pass.substring(0,200) }}></span>
                    // <span>{ statement.content.pass.substring(0,200) }...</span>
                  ):(
                    <span dangerouslySetInnerHTML={{ __html: statement.content.pass }}></span>
                    // <span>{ statement.content.pass }</span>
                  )}
                </div>
              )}
            </div>

            <div 
              onClick={() => {
                update("metas.currentContentAction", "fail")
                update("actives.statement.content.fail", statement.content.fail)
                clickFn(statement, "content", "fail")
              }}
              className="w-full flex flex-col"
            >
              { statement.content.fail !== null ? (
                <div className="w-full bg-red-900/50 px-2 py-1">
                  { expanded === false ? (
                    <span dangerouslySetInnerHTML={{ __html: statement.content.fail.substring(0,200) }}></span>
                    // <span>{ statement.content.fail.substring(0,200) }...</span>
                  ):(
                    <span dangerouslySetInnerHTML={{ __html: statement.content.fail }}></span>
                    // <span>{ statement.content.fail }</span>
                  )}
                </div>
              ):(
                <div className="w-full bg-red-900/50 px-2 py-1">
                  <span>[No fail statement]</span>
                </div>
              )}
            </div>

          </div>
        </div>
      </ElementBox>
    </Sortable>
  )
}